export class Navigation{
	init(){
		$('.site-header li').each(function() {
			var $this = $(this);
			if($this.children('.submenu').length){
				$this.addClass('has-child');
			}else if($this.children('ul').length){
				$this.addClass('has-list');

				var w = $this.innerWidth();
				$this.closest('.submenu').css('width',  w+=w);
			}
		});

		var dropdown = $('.site-header__left .dropdown-menu'),
			w = dropdown.find('strong').outerWidth();

			dropdown.find('ul').width(Math.floor(w));

		var len = $('.articles-list--3').find('.articles-list__item').length;
		len == 3 ? '' : $('.offers-button').hide();
	}
}